// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3niST","filesListContainer":"PosDisputesFiles_filesListContainer__1cAFI","filesButton":"PosDisputesFiles_filesButton__2vsyl"};